import styled from "styled-components";
// 세그먼트 버튼: options 중 하나를 고른다
const SelectOne = ({ options, vertical, selected, setSelected }) => {
  return (
    <Div vertical={vertical} role="group">
      {options?.map((x, idx) => {
        return (
          <button type="button" key={idx} aria-pressed={selected === idx} onClick={() => setSelected(idx)}>
            {x}
          </button>
        );
      })}
    </Div>
  );
};
export default SelectOne;
const Div = styled.div`
  display: inline-flex;
  flex-direction: ${({ vertical }) => (vertical ? "column" : "row")};
  gap: 0.2rem;
  padding: 0.2rem;
  border-radius: 999px;
  background-color: ${({ theme }) => theme.colors.monotone.extralight};
  border: 1px solid ${({ theme }) => theme.colors.line};
  font-size: 0.85em;
  & > button {
    cursor: pointer;
    border: 0;
    border-radius: 999px;
    padding: 0.3rem 0.8rem;
    background: transparent;
    color: ${({ theme }) => theme.colors.foreground.dimmed};
    font-size: inherit;
    font-weight: 600;
    transition: background-color 0.15s, color 0.15s;
    &[aria-pressed="true"] {
      background-color: ${({ theme }) => theme.colors.dark};
      color: white;
    }
  }
`;
